import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const dashCategoriesInit = {
  dashboardCategories: {},
};

function dashCategoriesReducer(draft, { type, payload }) {
  switch (type) {
    case "setDashCategories" : {
      let newState = {}
      // if not normalized
      if (payload && payload.DashboardCategories) {
        if (payload.DashboardCategories.length) {
          for (let i = 0; i < payload.DashboardCategories.length; i++) {
              let dashCat = payload.DashboardCategories[i]
              newState[dashCat.id] = dashCat
          } 
        }
        draft.dashboardCategories = newState;
      } 
      else {
        // passing in the selectedDash with normalized categories
        draft.dashboardCategories = payload
      }
      break
    }
    default: {
      return null;
    }
  }
}

const [DashCategoriesContext, DashCategoriesDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function DashboardCategoriesProvider({ children }) {
  const [dashCategoriesStore, dispatch] = useImmerReducer(
    dashCategoriesReducer,
    dashCategoriesInit
  );

  return (
    <DashCategoriesContext.Provider value={dashCategoriesStore}>
      <DashCategoriesDispatchContext.Provider value={dispatch}>
        {children}
      </DashCategoriesDispatchContext.Provider>
    </DashCategoriesContext.Provider>
  );
}

export function useDashboardCategories() {
  return useContext(DashCategoriesContext);
}

export function useDashboardCategoriesDispatch() {
  return useContext(DashCategoriesDispatchContext);
}
